import { render, staticRenderFns } from "./xi-check-analysis.vue?vue&type=template&id=61b42170&scoped=true"
import script from "./xi-check-analysis.vue?vue&type=script&lang=js"
export * from "./xi-check-analysis.vue?vue&type=script&lang=js"
import style0 from "./xi-check-analysis.vue?vue&type=style&index=0&id=61b42170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b42170",
  null
  
)

export default component.exports